export enum LINKS {
  MAIN = 'https://jointhesupportnetwork.com',
  LOGIN = 'https://jointhesupportnetwork.gethealthie.com/',
  ABOUT_US = 'https://jointhesupportnetwork.com/about',
  FOR_PROVIDERS = 'https://jointhesupportnetwork.com/providers',
  PRIVACY_POLICY = 'https://jointhesupportnetwork.com/policy',
  TERMS_OF_SERVICE = 'https://jointhesupportnetwork.com/terms',
  WEBSITE_PRIVACY_POLICY = 'https://jointhesupportnetwork.com/website-privacy-policy',
  FAQ = 'https://jointhesupportnetwork.com/faq',
  CONTACT_US = 'mailto: support@jointhesupportnetwork.com',
  LINKEDIN = 'https://www.linkedin.com/company/join-the-support-network/',
  FACEBOOK = 'https://www.facebook.com/people/The-Support-Network/61556278231418/',
  INSTAGRAM = 'https://www.instagram.com/jointhesupportnetwork/',
  ADDITIONAL_CRISIS_RESOURCES = 'https://www.apa.org/topics/crisis-hotlines',
  CANCELLATION_POLICY = 'https://jointhesupportnetwork.com/cancellation-policy',
  HIPAA_NOTICE_OF_PRIVACY_PRACTICES = 'https://jointhesupportnetwork.com/hipaa-practices',
  INFORMED_CONSENT = 'https://jointhesupportnetwork.com/informed-consent',
  PRACTICE_POLICIES = 'https://jointhesupportnetwork.com/practice-policies',
  PRIVACY_PRACTICE = 'https://jointhesupportnetwork.com/privacy-practices',
  HEADWAY_PRIVACY_PRACTISE = 'https://headway.co/legal/privacy',
  HEADWAY_PAYMENT_TERMS = 'https://headway.co/legal/payment',
  HEADWAY_RESPONSIBILITIES = 'https://headway.co/legal/responsibility',
  RESPONSIBILITY = 'https://jointhesupportnetwork.com/responsibility',
  TELEHEALTH_CONSENT = 'https://headway.co/legal/telehealth-informed-consent',
  PAYMENT_GUARANTEE_CONSENT = 'https://headway.co/legal/treat-and-payment-guarantee-consent',
  STRIPE = 'https://stripe.com'
}
